export const emptyHelperText = '\u200B';